import React, { useState, useEffect } from 'react';
import { http } from '../fx-core';
import './CampaignDetails.scss';

export default function CampaignDetails() {
    const [campaignGroups, setCampaignGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedGroupId, setExpandedGroupId] = useState(null);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        if (isNaN(date)) return "Invalid Date";
        return date.toLocaleString('en-GB', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    };

    useEffect(() => {
        http.get({ url: 'treasurehunt/groups/expired/details' })
            .then(res => {
                if (res?.data?.success && Array.isArray(res.data.data)) {
                    console.log("Campaign Groups:", res.data.data);
                    setCampaignGroups(res.data.data);
                } else {
                    setError("Invalid response format");
                }
            })
            .catch(err => {
                setError(err?.response?.data?.message || err.message || "Error loading campaigns");
            })
            .finally(() => setLoading(false));
    }, []);

    const toggleDetails = (groupId) => {
        setExpandedGroupId(prev => (prev === groupId ? null : groupId));
    };

    if (loading) return <div className="loading">Loading expired campaigns...</div>;
    if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="campaign-details-container">
        <table className="campaign-table">
            <thead>
                <tr>
                    <th>Campaign Name</th>
                    <th>Start</th>
                    <th>End</th>
                    <th>Details</th>
                </tr>
            </thead>
            <tbody>
                {campaignGroups.map(group => (
                    <tr key={group.campaignGroupId}>
                        <td>{group.campaignName}</td>
                        <td>{formatDate(group.startDateTime)}</td>
                        <td>{formatDate(group.endDateTime)}</td>
                        <td>
                            <button
                                className="analytics-btn"
                                onClick={() => toggleDetails(group.campaignGroupId)}
                            >
                                {expandedGroupId === group.campaignGroupId ? "Hide" : "Click here"}
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>

        {campaignGroups.map(group => (
            expandedGroupId === group.campaignGroupId && (
                <div className="campaign-item-details" key={`details-${group.campaignGroupId}`}>
                    {/* <h4>Items in {group.campaignName}</h4> */}
                    <table className="nested-details-table">
                        <thead>
                            <tr>
                                <th>Area</th>
                                <th>Storefront</th>
                                <th>Product</th>
                                <th>Quantity</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {group.campaignItems.map((item, idx) => (
                                <tr key={idx}>
                                    <td>{item.communityName}</td>
                                    <td>{item.stallName}</td>
                                    <td>{item.itemName}</td>
                                    <td>{item.quantity}</td>
                                    <td>₹{item.price.toFixed(2)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )
        ))}
    </div>
);

}
